/**
 * Lightweight store for commanding the map from outside the Map component tree.
 *
 * Components outside <Map> (e.g. SchedulePanel) dispatch flyTo commands here.
 * MapContainer consumes them via useEffect and executes map.flyTo().
 */

import { create } from 'zustand';

interface MapCommand {
  type: 'flyTo';
  latitude: number;
  longitude: number;
  zoom?: number;
  timestamp: number;
}

interface MapCommandStore {
  pendingCommand: MapCommand | null;
  flyTo: (lat: number, lon: number, zoom?: number) => void;
  clearCommand: () => void;
}

export const useMapCommandStore = create<MapCommandStore>((set) => ({
  pendingCommand: null,
  flyTo: (latitude, longitude, zoom) =>
    set({
      pendingCommand: { type: 'flyTo', latitude, longitude, zoom, timestamp: Date.now() },
    }),
  clearCommand: () => set({ pendingCommand: null }),
}));
